(() => {
  angular
    .module('complianceFrameworkApp.complianceForums')
    .config(['$stateProvider', $stateProvider => {
      $stateProvider

        .state('application.compliance_forums.search', {
          url: '/search/:query',
          views: {
            '@application.compliance_forums': {
              templateUrl: '/templates/compliance_forums/search/search.html',
              controller: 'ForumsSearchController',
              controllerAs: 'vm'
            }
          }
        });
    }]);
})();
